// -------------------------------- IMPORTS -------------------------------- //

import dayjs from 'dayjs';

// -------------------------------- EXPORTS -------------------------------- //

/** Get the current position on the timeline */
export const getCurrentPosition = (date: string, zoom: number, timezoneOverride: string) => {
  const zoomMultiplier = zoom / 60;
  const startOfDay = dayjs(date).tz(timezoneOverride).add(12, `hours`).startOf(`day`).format();
  const currentTime = dayjs().tz(timezoneOverride);
  // const currentTime = dayjs().tz(timezoneOverride).add(30, `minute`); // TEST for when you want to change the current position manually

  return currentTime.diff(startOfDay, `seconds`) * zoomMultiplier;
};

/** Get the current time */
export const getCurrentTime = (timezoneOverride: string) => {
  return dayjs().tz(timezoneOverride).format();
};

/** Get the position from the last saved scoll position (convert seconds to pixels) */
export const getLastScrollPosition = (key: string, zoom: number) => {
  const zoomMultiplier: number = zoom / 60;
  const scrollSeconds: number = parseInt(localStorage.getItem(key) || '25200'); // Defaults to 7am in seconds
  return scrollSeconds * zoomMultiplier;
};

/** Save the last scroll position in local storage (convert pixels to seconds) */
export const setLastScrollPosition = (key: string, value: number, zoom: number) => {
  const zoomMultiplier: number = zoom / 60;
  const scrollSeconds: number = value / zoomMultiplier;
  localStorage.setItem(key, scrollSeconds.toString());
};

/** Get the gap in pixels between two times */
export const getGapBetweenTimes = (startDate?: string, endDate?: string, zoom: number = 1) => {
  if (!startDate || !endDate) return 0;
  return dayjs(endDate).diff(startDate, `minutes`) * zoom;
};

/** Get the time from a position */
export const getTimeFromPosition = (position: number, zoom: number, timezoneOverride: string) => {
  return dayjs()
    .tz(timezoneOverride)
    .startOf(`day`)
    .add(position / zoom, `minutes`)
    .format();
};
